import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../../constants';
import { getDisplayName, MyPureComponent } from '../../lib/react';

class Hoverable extends MyPureComponent {
  static propTypes = {
    hover: PropTypes.bool,
    wrapWith: PropTypes.node,
    onHover: PropTypes.func,
    onLeave: PropTypes.func,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    hover: undefined,
    wrapWith: 'div',
    onHover: () => {},
    onLeave: () => {},
    onChange: (hovering, event) => {},
  };

  constructor(props) {
    super(props);
    this.state = { hover: undefined };
  }

  render() {
    const {
      hover,
      wrapWith,
      onHover,
      onLeave,
      children,
      ...otherProps
    } = this.props;
    const Wrap = wrapWith;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        hover: hover || this.state.hover,
      }),
    );

    return (
      <Wrap
        onMouseEnter={this.onMouseEnter}
        onMouseOver={this.onMouseOver}
        onMouseLeave={this.onMouseLeave}
        {...otherProps}
      >
        {childrenWithProps}
      </Wrap>
    );
  }

  onMouseEnter = e => {
    if (this.state.hover === undefined) {
      this.setState({ hover: true });
      this.props.onHover(e);
      this.props.onChange(true, e);
    }
  };

  onMouseOver = e => {
    if (this.state.hover === undefined) {
      this.setState({ hover: true });
      this.props.onHover(e);
      this.props.onChange(true, e);
    }
  };

  onMouseLeave = e => {
    if (this.state.hover === true) {
      this.setState({ hover: undefined });
      this.props.onLeave(e);
      this.props.onChange(false, e);
    }
  };
}

class Hover extends MyPureComponent {
  static propTypes = {
    hover: PropTypes.bool,
    onHover: PropTypes.func,
    onLeave: PropTypes.func,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    hover: undefined,
    onHover: () => {},
    onLeave: () => {},
    onChange: (hovering, event) => {},
  };

  constructor(props) {
    super(props);
    this.state = { hover: undefined };
  }

  render() {
    const { hover, onHover, onLeave, children, ...otherProps } = this.props;

    const additionalProps = {
      onMouseEnter: this.onMouseEnter,
      onMouseOver: this.onMouseOver,
      onMouseLeave: this.onMouseLeave,
      hover: hover || this.state.hover,
      ...otherProps,
    };

    const child = React.Children.only(children);
    this.childProps = child.props;
    return React.cloneElement(child, additionalProps);
  }

  callChildProp = (e, propName) => {
    const func = this.childProps[propName];
    if (typeof func === 'function') {
      func(e);
    }
  };

  onMouseEnter = e => {
    if (this.state.hover === undefined) {
      this.setState({ hover: true });
      this.props.onHover(e);
      this.props.onChange(true, e);
    }
    this.callChildProp(e, 'onMouseEnter');
  };

  onMouseOver = e => {
    if (this.state.hover === undefined) {
      this.setState({ hover: true });
      this.props.onHover(e);
      this.props.onChange(true, e);
    }
    this.callChildProp(e, 'onMouseOver');
  };

  onMouseLeave = e => {
    if (this.state.hover === true) {
      this.setState({ hover: undefined });
      this.props.onLeave(e);
      this.props.onChange(false, e);
    }
    this.callChildProp(e, 'onMouseLeave');
  };
}

function withHover(options = EMPTY_OBJECT) {
  return function(WrappedComponent) {
    class WithHoverable extends MyPureComponent {
      render() {
        const { hover, ...otherProps } = this.props;
        return (
          <Hoverable hover={hover} wrapWith={options.wrapper}>
            <WrappedComponent {...this.props} />
          </Hoverable>
        );
      }
    }

    WithHoverable.displayName = `WithHoverable(${getDisplayName(
      WrappedComponent,
    )})`;

    return WithHoverable;
  };
}

export default Hoverable;
export { Hover, withHover };



// WEBPACK FOOTER //
// ./src/components/Hoverable/Hoverable.js